var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm, Controller } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAPI from '../../hooks/useAPI';
import useQuery from '../../hooks/useQuery';
import enLogo from '../../assets/mm_en-blue.png';
import frLogo from '../../assets/mm_fr-blue.png';
import { Button, Input, PasswordStrength } from '../../Components';
var ResetPassword = function () {
    var _a = __read(useState(false), 2), showSuccess = _a[0], setShowSuccess = _a[1];
    var _b = __read(useState(false), 2), matchError = _b[0], setMatchError = _b[1];
    var _c = __read(useState(false), 2), strength = _c[0], setStrength = _c[1];
    var _d = __read(useState(''), 2), emailVal = _d[0], setEmail = _d[1];
    var _e = __read(useState(''), 2), token = _e[0], setToken = _e[1];
    var _f = __read(useState(''), 2), id = _f[0], setId = _f[1];
    var _g = useForm(), handleSubmit = _g.handleSubmit, control = _g.control, watch = _g.watch, setFocus = _g.setFocus, setValue = _g.setValue;
    var params = useQuery();
    var history = useHistory();
    var _h = useTranslation(), t = _h.t, i18n = _h.i18n;
    var _j = useAPI(), post = _j.post, loading = _j.loading, error = _j.error, success = _j.success;
    useEffect(function () {
        var token = params.get('token');
        var id = params.get('id');
        var email = params.get('email');
        if (email) {
            setEmail(email);
        }
        if (!token || !id) {
            history.push('/login');
        }
        else {
            setId(id);
            setToken(token);
        }
    }, []);
    var passwordValue = watch('password');
    var onSubmit = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var data;
        var password = _b.password, confirmPassword = _b.confirmPassword;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setShowSuccess(false);
                    if (password !== confirmPassword) {
                        setMatchError(true);
                        return [2 /*return*/];
                    }
                    if (!strength) {
                        setFocus('password');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, post('auth/resetpassword', { password: password, id: id, token: token })];
                case 1:
                    data = _c.sent();
                    if (data.success) {
                        setShowSuccess(true);
                        history.push('/login?passwordchange');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", { className: "bg-gray-50 flex flex-col items-center min-h-screen justify-center px-5 py-6", children: _jsxs("div", { className: "mt-8 bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 text-center w-full max-w-xl", children: [_jsx("div", { className: "h-20 my-10 flex justify-center", children: _jsx("img", { src: i18n.language === 'en' ? enLogo : frLogo, className: "h-20", alt: "M&M Markets Logo" }) }), _jsx("p", { className: "text-lg tracking-tight mb-8", children: t('resetPassword:reset_password_headline') }), emailVal.length ? _jsxs("p", { className: "tracking-tight mb-8", children: ["Hello ", emailVal] }) : '', _jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "flex flex-col items-center space-y-5 px-24", children: [_jsx(Controller, { control: control, name: "password", render: function (_a) {
                                var _b = _a.field, onChange = _b.onChange, value = _b.value, name = _b.name;
                                return (_jsx(Input, { value: value, onChange: onChange, type: "password", id: name, label: t('global:password'), required: true }));
                            } }), _jsx(PasswordStrength, { value: passwordValue, canPass: setStrength }), _jsx(Controller, { control: control, name: "confirmPassword", render: function (_a) {
                                var _b = _a.field, onChange = _b.onChange, value = _b.value, name = _b.name;
                                return (_jsx(Input, { value: value, onChange: onChange, type: "password", id: name, label: t('global:confirmpassword'), required: true }));
                            } }), error && _jsx("p", { className: "text-red-500", children: t("api:".concat(error)) }), showSuccess && _jsx("p", { className: "text-green-500", children: t('resetPassword:password_email_success') }), matchError && _jsx("p", { className: "text-red-500", children: t('resetPassword:no_match') }), _jsx("div", { className: "mt-16", children: _jsx(Button, { type: "submit", loading: loading, children: t('global:reset') }) }), _jsx("p", { children: _jsx(Link, { to: "/login", className: "text-darkblue underline", children: t('global:back_to_login') }) })] })] }) }));
};
export default ResetPassword;
